export default (url, newTab = false) => {
    console.log({redirect: url})
    if (newTab || url.match(/^http:\/\/localhost/)) {
        window.open(url)
    } else {
        window.location.href = url
    }
}